import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useScriptsStore} from '../scripts-store'

export const ToolsHelp = observer(() => {
  const [, store] = useScriptsStore()

  return (
    <div className="scr-help-nav">
      <ul>
        <li>
          <button onClick={store.goToFeedback}>{Lang.msg.helpWriteUs1}</button>
          {Lang.msg.helpWriteUs2}
        </li>
        <li>
          <a
            className="_link"
            href="/media/docs/yougile-api-manual.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {Lang.msg.helpReadMan1}
          </a>
          {Lang.msg.helpReadMan2}
        </li>
        <li>
          <a
            className="_link"
            href="https://youtu.be/UOKxyTRv0Bo"
            target="_blank"
            rel="noopener noreferrer"
          >
            {Lang.msg.helpWatchVid1}
          </a>
          {Lang.msg.helpWatchVid2}
        </li>
      </ul>
    </div>
  )
})
